import { PageId } from '@shared/protos/routes';
import { useState } from 'react';
import { MobileNavBarButton } from './MobileNavBarButton';
import { ReferenceMenuPopup } from './ReferenceMenuPopup';

export default function ReferenceMenuNavItem() {
  const [referenceMenuAnchorEl, setReferenceMenuAnchorEl] = useState<HTMLButtonElement | null>(null);
  const openReferenceMenuPopover = Boolean(referenceMenuAnchorEl);
  const referenceMenuPopoverId = openReferenceMenuPopover ? 'reference-menu-popover' : undefined;

  const handleOpenReferenceMenu = (event: React.MouseEvent<HTMLButtonElement>) => setReferenceMenuAnchorEl(event.currentTarget);

  const handleCloseReferenceMenu = () => setReferenceMenuAnchorEl(null);

  return (
    <>
      <MobileNavBarButton
        onClick={handleOpenReferenceMenu}
        icon="ri-compass-line"
        label="Explore"
        pageId={PageId.reference}
        data-testid="reference-menu-nav-item-mobile"
      />
      <ReferenceMenuPopup
        id={referenceMenuPopoverId}
        anchorEl={referenceMenuAnchorEl}
        open={openReferenceMenuPopover}
        onClose={handleCloseReferenceMenu}
      />
    </>
  );
}
